import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import {
  AswMasterService,
  CommonLibService,
  ErrorsHandlerService,
  LoggerDatadogService,
  PageLoadingService,
} from '@lib/services';
import { ErrorType, NotRetryableErrorModel, PageType, SessionStorageName } from '@lib/interfaces';
import { RoundtripFlightAvailabilityInternationalState } from '@common/store/roundtripFlightAvailabilityInternational';
import { RoundtripFlightAvailabilityInternationalService } from '@common/services/roundtripFlightAvailabilityInternational/roundtripFlightAvailabilityInternational.service';
import { AirOfferUpgradeInfo, FlightUpgradeInfo } from '@common/interfaces/roundtripFlightAvailabilityInternational';
import { Flights } from '@common/interfaces/shopping/roundtrip-owd/response/data/airOffers/flights';
import { Type9 } from 'src/sdk-search/model/type9';
import { Bounds } from '@common/interfaces/shopping/roundtrip-owd';
import {
  UpgradeDetailInforParam,
  FareFamiliesRule,
} from '@common/components/shopping/fare-family-selector-modal-rule/fare-family-selector-modal-rule.state';
import { Segment } from '@common/components/shopping/fare-family-selector-modal-rule/fare-family-selector-modal-rule.state';
import { MASTER_TABLE, MasterStoreKey } from '@conf/asw-master.config';
import { ServiceContentsByItineraryTypeModel } from '@common/interfaces/common/ServiceContentsByItineraryTypeCabin/ServiceContentsByItineraryType';
import { ServiceContentsByItineraryTypeCabin } from '@common/interfaces/common/ServiceContentsByItineraryTypeCabin/ServiceContentsByItineraryType_Cabin';
import { ServiceContentsByItineraryTypeServiceType } from '@common/interfaces/common/ServiceContentsByItineraryTypeCabin/ServiceContentsByItineraryType_ServiceType';
import { Type5ItinerariesInner } from 'src/sdk-search';
import { UpgradeAvailabilityRequest } from '@common/interfaces/shopping/upgrade-availability/upgradeavailabilityRequest';
import { UpgradeAvailabilityService } from '@common/services/upgrade-availability/upgrade-availability-store.service';
import { UpgradeAvailabilityState } from '@common/store/upgrade-availability';
import { UpgradeWaitlistRequest } from '@common/interfaces/shopping/upgrade-waitlist/upgradeWaitlistRequest';
import { UpgradeWaitlistStoreService } from '@common/services/upgrade-waitlist/upgrade-waitlist-store.service';
import { UpgradeWaitlistState } from '@common/store/upgrade-waitlist';
import { CommonSliderComponent } from '@common/components/shopping/common-slider/common-slider.component';
import { availabilityInformationForDepartureDate } from '@common/interfaces/shopping/upgrade-availability/upgradeavailabilityResponsesForDepartureDate';
import { vacantInformationForFlight } from '@common/interfaces/shopping/upgrade-availability/upgradeavailabilityResponsesForFlight';
import { FareFamilySelectorModalComponent } from '../fare-family-selector/fare-family-selector-modal.component';
import { M_OFFICE } from '@common/interfaces/common/m_office';
import { AirportI18nJoinByAirportCodeCache } from '@common/services/shopping/shopping-lib/shopping-lib.state';
import { SearchFlightConditionForRequestState } from '@common/store/search-flight-condition-for-request';
import { SearchFlightConditionForRequestService } from '@common/services';
import { StaticMsgPipe } from '@lib/pipes';
import { environment } from '@env/environment';

/**
 * FF選択モーダル
 * FF情報のFFルール、セグメント情報画面部品
 */
@Component({
  selector: 'asw-fare-family-selector-modal-rule',
  templateUrl: './fare-family-selector-modal-rule.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FareFamilySelectorModalRuleComponent extends SupportComponent implements AfterViewInit {
  /** 往復空席照会結果(国際)画面のStore */
  private _R01P030Store: RoundtripFlightAvailabilityInternationalState = {};
  /** リクエスト用検索条件 */
  public searchFlightCondition?: SearchFlightConditionForRequestState;

  // 空席照会時アップグレード可否照会リクエスト
  private _upgradeAvailabilityRequest!: UpgradeAvailabilityRequest;
  // 空席照会時アップグレード可否照会レスポンス
  private _upgradeAvailability: UpgradeAvailabilityState = { requestIds: [] };

  // アップグレード空席待ち人数取得リクエスト
  private _upgradeWaitlistRequest!: UpgradeWaitlistRequest;
  // アップグレード空席待ち人数取得レスポンス
  private _upgradeWaitlist: UpgradeWaitlistState = { requestIds: [] };

  // 空港情報キャッシューデータ取得
  private airportAkamai: AirportI18nJoinByAirportCodeCache = {};

  // 往復空席storeアップグレード情報リスト
  private storeUpgradeList: Array<AirOfferUpgradeInfo> = [];
  // 当該セグメント.アップグレード情報リスト
  private upgradeListSeg: Array<FlightUpgradeInfo> = [];

  /** 当部品のスライド番号 */
  @Input()
  public slideNum: number = 0;
  /** 全体のスライド番号 */
  @Input()
  public slideMax: number = 0;

  @Input()
  public allUpgradeLink: boolean = false;

  @Output()
  public changeAllUpgradeLink = new EventEmitter<UpgradeDetailInforParam>();

  /** FFルール オブジェクト */
  @Input()
  public fareFamiliesRule: FareFamiliesRule = {};
  @Input()
  public fareFamilyName: string = '';
  @Input()
  public fareFamilyCode: string = '';
  @Input()
  public cabinClass: string = '';
  /**  セグメント情報 オブジェクト */
  @Input()
  public segmentList: Segment[] = [];
  /** セグメント情報(TravelSolution配下のflight) */
  public _travelSolutionsFlightsList: Type9[] = [];
  /** セグメント関連情報リ(AirOffer配下のBounds.flight) */
  public _airOffersFlightsList: Flights[] = [];
  /** 当該bound.flights ※AirOffer配下のBounds */
  public _airOfferBounds: Bounds = {};
  /** ANAカウチ利用可否フライトIndexリスト */
  public _anaCouchIsEnabledFlightIndexList: number[] = [];

  /**  縦サイズ 他のFF情報部品と高さを合わせるため外部入力 */
  /**  縦サイズを合わせるためのFF部品 */
  @ViewChildren('fixHeight') fixHeight!: ElementRef[];

  /** FF選択一覧スクロールの要素を取得する変数 */
  @ViewChildren('scrollItemList') scrollItemList?: QueryList<ElementRef>;

  /** 検索結果種別 */
  public searchResultItineraryType: string = '';
  /** 当該バウンドアップグレード情報マップ */
  public _upgradeInfoList: FlightUpgradeInfo[] = [];
  /** 当該セグメントアップグレード情報リスト */
  public upgradeInfo?: FlightUpgradeInfo;

  /** アップグレード照会可となるseatStatus */
  public verifiableSeatStatus = ['available', 'waitlisting', 'acquired', 'unacquired'];

  /** アップグレード照会不可となるseatStatus */
  public notVerifiableSeatStatus = ['noSetting', 'occupied'];

  /** FF情報部品（予約変更可否等が記載されている箇所）の高さ */
  public height3Max = 0;
  /** FF情報部品（各フライト毎の提供サービスが記載されている箇所）の高さ */
  public height4Max = 0;
  /** ANAアプリであるか判定 */
  public isAnaApl = false;

  constructor(
    private _common: CommonLibService,
    private _roundtripFlightAvailabilityInternationalService: RoundtripFlightAvailabilityInternationalService, //往復空席照会結果画面store
    private _upgradeAvailabilityService: UpgradeAvailabilityService, // 空席照会時アップグレード可否照会API(store)： upgrade-availability
    private _upgradeWaitlistService: UpgradeWaitlistStoreService, // アップグレード空席待ち人数取得API(store)： upgrade-waitlist
    private _commonSliderComponent: CommonSliderComponent,
    private _aswMasterSvc: AswMasterService,
    private _errorsHandlerSvc: ErrorsHandlerService,
    private _fareFamilySelectorModalComponent: FareFamilySelectorModalComponent,
    private _searchFlightConditionForRequestService: SearchFlightConditionForRequestService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _staticMsgPipe: StaticMsgPipe,
    private _renderer: Renderer2,
    private _pageLoadingService: PageLoadingService,
    private _loggerSvc: LoggerDatadogService
  ) {
    super(_common);

    this.isAnaApl = this._common.aswContextStoreService.aswContextData.isAnaApl;
    this.subscribeService(
      'FareFamilySelectorModalRule_R01P030Store',
      this._roundtripFlightAvailabilityInternationalService.getRoundtripFlightAvailabilityInternationalObservable(),
      (response) => {
        //往復空席照会画面storeから値を取得
        this._R01P030Store = response;
        this.storeUpgradeList = this._R01P030Store.upgradeInfoList as Array<AirOfferUpgradeInfo>;
      }
    );
  }

  /** セグメント情報(TravelSolution配下のflight) */
  @Input()
  set travelSolutionsFlightsList(tsFlightList: Type9[]) {
    this._travelSolutionsFlightsList = tsFlightList;
  }
  get travelSolutionsFlightsList() {
    return this._travelSolutionsFlightsList;
  }

  /** 当該バウンドアップグレード情報マップ */
  @Input()
  set upgradeInfoList(upgradeInfoList: FlightUpgradeInfo[]) {
    this._upgradeInfoList = upgradeInfoList;
  }
  get upgradeInfoList() {
    return this._upgradeInfoList;
  }

  /** セグメント関連情報リスト(AirOffer配下のBounds.flight) */
  @Input()
  set airOffersFlightsList(aoFlightList: Flights[]) {
    this._airOffersFlightsList = aoFlightList;
  }
  get airOffersFlightsList() {
    return this._airOffersFlightsList;
  }

  /** 当該bound.flights ※AirOffer配下のBounds */
  @Input()
  set airOfferBounds(airOfferBounds: Bounds) {
    this._airOfferBounds = airOfferBounds;
  }
  get airOfferBounds() {
    return this._airOfferBounds;
  }

  /** ANAカウチ利用可否フライトIndexリスト */
  @Input()
  set anaCouchIsEnabledFlightIndexList(anaCouchIndexList: number[]) {
    this._anaCouchIsEnabledFlightIndexList = anaCouchIndexList;
  }
  get anaCouchIsEnabledFlightIndexList() {
    return this._anaCouchIsEnabledFlightIndexList;
  }

  reload(): void {}
  init(): void {
    // セグメント情報(リスト) 作成メソッドを呼び出し、セグメント情報部分の表示値を作成
    this.subscribeService(
      'PushUpgradeAvailability',
      this._roundtripFlightAvailabilityInternationalService.getRoundtripFlightAvailabilityInternationalObservable(),
      () => {
        this.segmentList = [];
        this.getFareFamilySegmentList(
          this.travelSolutionsFlightsList,
          this.airOffersFlightsList,
          this.anaCouchIsEnabledFlightIndexList
        );
        this._changeDetectorRef.detectChanges();
      }
    );
  }
  destroy(): void {
    this.deleteSubscription('_upgradeWaitlist');
    this.deleteSubscription('_upgradeAvailability');
    this.deleteSubscription('PushUpgradeAvailability');
  }

  ngAfterViewInit(): void {
    if (this._commonSliderComponent) {
      this._commonSliderComponent.scrollItemList = this.scrollItemList;
    }

    const lastfarePanelHeadElement = document.getElementById(`p-fare-panel__body3-${this.slideMax - 1}`);
    if (lastfarePanelHeadElement) {
      this.alignFarePanel('p-fare-panel__body3-', this.height3Max);
    }

    const lastfarePanelBodyElement = document.getElementById(`p-fare-panel__body4-${this.slideMax - 1}`);
    if (lastfarePanelBodyElement) {
      this.alignFarePanel('p-fare-panel__body4-', this.height3Max);
    }
  }

  /** FF情報部品の高さをそろえる */
  private alignFarePanel(id: string, height: number) {
    const htmlElementArray: HTMLElement[] = [];
    for (let i = 0; i < this.slideMax; i++) {
      const element = document.getElementById(`${id}${i}`);
      if (element) {
        htmlElementArray.push(element);
      }
    }

    for (let i = 0; i < htmlElementArray.length; i++) {
      const element = htmlElementArray[i];
      if (element.offsetHeight > height) {
        height = element.offsetHeight;
      }
    }

    htmlElementArray.forEach((el) => {
      this._renderer.setStyle(el, 'height', `${height}px`);
    });
  }

  /**
   * セグメント情報 作成メソッド ※itemコンポーネントでの表示値
   *
   * @param travelSolutionsFlightsList セグメント情報リスト
   * @param airOffersFlightsList セグメント関連情報リスト
   * @param anaCouchIsEnabledFlightIndexList ANAカウチ利用可否表示フライトIDリスト
   */
  public getFareFamilySegmentList(
    travelSolutionsFlightsList: Type9[],
    airOffersFlightsList: Flights[],
    anaCouchIsEnabledFlightIndexList: number[]
  ): void {
    // セグメント情報=フライト詳細で空港コードのみのため、JoinByAirportCodeCache
    this.airportAkamai = this._aswMasterSvc.aswMaster[MASTER_TABLE.AIRPORT_I18N_JOIN_BY_AIRPORT_CODE.key];
    // セグメント情報リストの件数分繰り返し
    travelSolutionsFlightsList.forEach((travelSolutionsFlights, tsIndex) => {
      // 出発地　空港名取得処理
      let departureAirport = '';
      let departureAirports = this.airportAkamai[travelSolutionsFlights.departure?.locationCode!];
      if (departureAirports && departureAirports.length !== 0) {
        for (let i = 0; i < departureAirports.length; i++) {
          if (departureAirports[i].airport_code === travelSolutionsFlights.departure?.locationCode!) {
            departureAirport = departureAirports[i].airport_name;
            break;
          }
        }
      } else {
        // 空港コードに該当するデータが取得できないか空だった場合、運用確認ログを出力する
        this._loggerSvc.operationConfirmLog('MST0003', {
          0: MASTER_TABLE.AIRPORT_I18N_JOIN_BY_AIRPORT_CODE.fileName,
          1: travelSolutionsFlights.departure?.locationCode!,
        });
      }
      // 当該flight.departure.locationCode=空港コードとなるASWDB(マスタ)の空港のレコードが存在しない場合、当該flight.departure.locationName
      if (departureAirport === '') {
        departureAirport = travelSolutionsFlights.departure?.locationName ?? '';
      }

      // 当該セグメントアップグレード情報リストを取得する
      this.upgradeInfo = this.storeUpgradeList
        .find((airoffer) => airoffer.airOfferId === this._R01P030Store.ffSelectModalList?.[this.slideNum].airOfferId)
        ?.boundUpgradeInfoList?.find(
          (boundUpgradeInfo) => boundUpgradeInfo.travelSolutionId === this.airOfferBounds.travelSolutionId
        )
        ?.flightUpgradeInfoList?.find(
          (value) =>
            value.segmentKey ===
            `${travelSolutionsFlights.marketingAirlineCode}${travelSolutionsFlights.marketingFlightNumber}`
        );

      // 到着地　空港名取得処理
      let arrivalAirport = '';
      if (this.airportAkamai[travelSolutionsFlights.arrival?.locationCode!]) {
        let arrivalAirports = this.airportAkamai[travelSolutionsFlights.arrival?.locationCode!];
        for (let i = 0; i < arrivalAirports.length; i++) {
          if (arrivalAirports[i].airport_code === travelSolutionsFlights.arrival?.locationCode!) {
            arrivalAirport = arrivalAirports[i].airport_name;
            break;
          }
        }
      }
      // 当該flight.arrival.locationCode=空港コードとなるASWDB(マスタ)の空港レコードが存在しない場合、当該flight.arrival.locationName
      if (arrivalAirport === '') {
        arrivalAirport = travelSolutionsFlights.arrival?.locationName ?? '';
      }

      // (25-39) ANAカウチ利用可否 ANAカウチ表示可否
      let isShowAnaCouchOne: boolean = false;
      // ANAカウチ利用可否表示フライトIDリストに当該flight.idが含まれる場合、表示可否＝true
      anaCouchIsEnabledFlightIndexList.forEach((couchIndex) => {
        if (couchIndex === tsIndex) {
          isShowAnaCouchOne = true;
        }
      });

      let itineraryType: string = ''; // セグメント区分

      // お食事・お飲み物 ～ ラウンジ 表示可否判定用変数
      let _isEnabledMeal: boolean = false; // お食事・お飲み物
      let _isEnabledEntertainment: boolean = false; // エンターテイメント
      let _isEnabledShopping: boolean = false; // ショッピング
      let _isEnabledAmenity: boolean = false; // アメニティ
      let _isEnabledSeat: boolean = false; // 座席
      let _isWiFiServiceAll: boolean = false; // Wi-Fi Wi-Fiサービスあり
      let _isWiFiServiceASegment: boolean = false; // Wi-Fi  Wi-Fiサービス可能性あり
      let _isEnabledLounge: boolean = false; // ラウンジ

      // お食事・お飲み物 ～ ラウンジ ツールチップ内文言用変数
      let _tooltipMeal: string = ''; // お食事・お飲み物
      let _tooltipEntertainment: string = ''; // エンターテイメント
      let _tooltipShopping: string = ''; // ショッピング
      let _tooltipAmenity: string = ''; // アメニティ
      let _tooltipSeat: string = ''; // 座席
      let _tooltipLounge: string = ''; // ラウンジ

      // 以下、当該セグメント関連情報.isNhGroupOperated=true(NHグループ運航便)を条件に含む場合、
      // 条件を満たすASWDB(マスタ)サービスコンテンツ.サービス説明に応じて表示する。
      if (travelSolutionsFlights.isNhGroupOperated === true) {
        // サービスコンテンツキャッシュからサービスタイプ(リスト)を取得
        // セグメント区分に国際：'I'または、国内：'D'を設定
        if (travelSolutionsFlights.isJapanDomesticFlight === true) {
          itineraryType = 'D';
        } else {
          itineraryType = 'I';
        }

        // 国際旅程で日本発着国際線のキャビン指定がビジネスまたはプレミアムエコノミーの場合、下位キャビン（エコ）に変換する。
        let _cabinClassConvert: string = '';
        if (itineraryType === 'D' && (this.cabinClass === 'business' || this.cabinClass === 'ecoPremium')) {
          _cabinClassConvert = 'eco';
        } else {
          _cabinClassConvert = this.cabinClass;
        }

        // セグメント区分とキャビンクラスを指定し、キャッシュからサービスタイプ(リスト)を取得
        let serviceContentsByItineraryTypeServiceType: ServiceContentsByItineraryTypeServiceType[];
        serviceContentsByItineraryTypeServiceType = this.getServiceContentsByItineraryType(
          _cabinClassConvert,
          itineraryType
        );

        // 取得したサービスタイプ(リスト)を繰り返し、サービスタイプに応じて表示可否にtrue,
        // ツールチップ内文言にサービスコンテンツ.サービス説明を設定
        serviceContentsByItineraryTypeServiceType.forEach((serviceType) => {
          if (serviceType.service_type === '1') {
            if (airOffersFlightsList[tsIndex].flightServices?.isLoungeAvailable) {
              _isEnabledLounge = true;
              _tooltipLounge = serviceType.service_sentence ?? '';
            }
          }
          if (serviceType.service_type === '2') {
            _isEnabledSeat = true;
            _tooltipSeat = serviceType.service_sentence ?? '';
          }
          if (serviceType.service_type === '3') {
            _isEnabledMeal = true;

            // 当該セグメント関連情報.flightServices.availableMeals≠””(空欄)の場合、
            // availableMealsに紐づくツールチップ文言を指定して、ツールチップアイコン(G02-011)を表示する。
            if (airOffersFlightsList[tsIndex].flightServices?.availableMeals !== undefined) {
              if (airOffersFlightsList[tsIndex].flightServices?.availableMeals === 'S') {
                _tooltipMeal = 'S';
              }
              if (airOffersFlightsList[tsIndex].flightServices?.availableMeals === 'M') {
                _tooltipMeal = 'M';
              }
              if (airOffersFlightsList[tsIndex].flightServices?.availableMeals === 'R') {
                _tooltipMeal = 'R';
              }
              if (airOffersFlightsList[tsIndex].flightServices?.availableMeals === 'N') {
                _tooltipMeal = 'N';
              }
              // 上記以外の場合、サービスコンテンツ.サービス説明を指定して、ツールチップアイコン(G02-011)を表示する。
            } else {
              _tooltipMeal = serviceType.service_sentence ?? '';
            }
          }
          if (serviceType.service_type === '4') {
            _isEnabledEntertainment = true;
            _tooltipEntertainment = serviceType.service_sentence ?? '';
          }
          if (serviceType.service_type === '5') {
            _isEnabledShopping = true;
            _tooltipShopping = serviceType.service_sentence ?? '';
          }
          if (serviceType.service_type === '6') {
            _isEnabledAmenity = true;
            _tooltipAmenity = serviceType.service_sentence ?? '';
          }
        });
      }

      // Wi-Fi 判定処理
      // 当該flight.isNhGroupOperated=true(NHグループ運航便)の場合、以下条件に従い設定する。
      if (travelSolutionsFlights.isNhGroupOperated) {
        // 当該flight.wiFiType=”1”(あり)
        if (travelSolutionsFlights.flightServices?.wiFiType === '1') {
          _isWiFiServiceAll = true;
        }
        // 当該flight.wiFiType=”2”(可能性あり)
        if (travelSolutionsFlights.flightServices?.wiFiType === '2') {
          _isWiFiServiceASegment = true;
        }
      }

      // アップグレード空席状況 リスト
      // 往復空席画面store.アップグレード情報リストから、当該セグメントのアップグレード空席状況を取り出し、追加
      let upgradeRemainSeatResultList: Array<FlightUpgradeInfo> = [];
      if (travelSolutionsFlights.id) {
        upgradeRemainSeatResultList = this.getStoreUpgradeList(upgradeRemainSeatResultList, travelSolutionsFlights.id);
      }

      /**
       * アップグレード案内
       * 以下の条件を全て満たす場合true
       * 1　当該セグメント情報.isNhGroupOperated = true(NHグループ)
       * 2　当該セグメント情報.isJapanDomesticFlight = false(国内線でない)
       * 3　当該セグメント関連情報.cabin != 'first'(ファーストクラスでない)
       */
      let _isShowUpgrade: boolean = false;
      if (travelSolutionsFlights.isNhGroupOperated === true) {
        if (travelSolutionsFlights.isJapanDomesticFlight === false) {
          if (this.cabinClass !== 'first') {
            _isShowUpgrade = true;
          }
        }
      }

      /**
       * アップグレード可否
       * 以下の処理にて求めた値をアップグレード可否とする
       * 1　アップグレード可否を初期値falseとする
       * 2　当該セグメントアップグレード情報の要素数分繰り替えし、当該アップグレード情報.残席状況 != ”occupied”、”noSetting”の場合、アップグレード可否をtrueとし、繰り返し処理を終了する。
       * ※アップグレードアイコン内のテキストの表示制御の為、当該アップグレード情報.残席状況 = "available"の場合true(表示なし)を設定
       */
      let _isEnabledUpgrade: boolean = false;
      let _isEnabledUpgradeContents: boolean = false;
      let _isEnabledSeatAcquisition: boolean = false;
      for (
        let i = 0;
        this.upgradeInfo &&
        this.upgradeInfo?.cabinClassUpgradeInfoList &&
        i < this.upgradeInfo.cabinClassUpgradeInfoList.length;
        i++
      ) {
        if (
          this.upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus !== 'occupied' &&
          this.upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus !== 'noSetting'
        ) {
          _isEnabledUpgrade = true;
          break;
        }
        if (this.upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus === 'available') {
          _isEnabledUpgradeContents = true;
        }
      }

      /**
       *  アップグレード詳細取得
       *  以下の全ての条件を満たす場合、true(活性表示)
       *  1 ユーザ共通.ログインステータス≠未ログイン
       *  2 当該セグメントアップグレード情報の要素数分、繰り返し、当該アップグレード情報.残席状況=“unacquired”or"waitlisting"が1つでも存在する
       */
      // 未ログインチェック
      if (!this.isNotLogin()) {
        for (
          let i = 0;
          this.upgradeInfo &&
          this.upgradeInfo?.cabinClassUpgradeInfoList &&
          i < this.upgradeInfo.cabinClassUpgradeInfoList.length;
          i++
        ) {
          if (
            this.upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus === 'unacquired' ||
            this.upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus === 'waitlisting'
          ) {
            _isEnabledSeatAcquisition = true;
          }
        }
      }

      // 検索結果種別を画面storeから取得
      this.searchResultItineraryType = this._R01P030Store.searchResultItineraryType ?? 'international';

      // セグメント情報　の作成処理
      let segment: Segment = {
        // セグメントID
        segmentId: travelSolutionsFlights.id,
        // 出発地
        departureAirport: departureAirport ?? travelSolutionsFlights.departure?.locationName!,
        // 到着地
        arrivalAirport: arrivalAirport ?? travelSolutionsFlights.arrival?.locationName!,
        // (25-37) 座席指定料金
        seatReservationFee: airOffersFlightsList[tsIndex].seat?.applicability,
        // (25-38) シートマップ
        isShowSeatmap:
          travelSolutionsFlights.isNhGroupOperated === true || travelSolutionsFlights.isJapanDomesticFlight === true
            ? true
            : false,
        // ANAカウチ利用可否 ANAカウチ表示可否
        isCouchDisplay: isShowAnaCouchOne,
        // ANAカウチ利用可否
        isEnabledAnaCouch: airOffersFlightsList[tsIndex].isCouchAvailable ?? false,
        // アップグレード案内 表示有無
        isShowUpgrade: _isShowUpgrade,
        // アップグレード可否
        isEnabledUpgrade: _isEnabledUpgrade,
        // アップグレード詳細取得 可否
        isEnabledSeatAcquisition: _isEnabledSeatAcquisition,
        // アップグレード空席状況 リスト ※(25-44)キャビンクラス、(25-45)残席状況 含む
        upgradeRemainSeatList: upgradeRemainSeatResultList,
        // お食事・お飲み物　お食事利用可否
        isEnabledMeal: _isEnabledMeal,
        // お食事・お飲み物　お食事ツールチップ
        tooltipMeal: _tooltipMeal,
        // お食事・お飲み物　お飲み物利用可否
        isEnabledDrink: true,
        // お食事・お飲み物　お飲み物ツールチップ
        tooltipDrink: undefined,
        // エンターテイメント 利用可否
        isEnabledEntertainment: _isEnabledEntertainment,
        // エンターテイメント ツールチップ
        tooltipEntertainment: _tooltipEntertainment,
        // ショッピング　利用可否
        isEnabledShopping: _isEnabledShopping,
        // ショッピング　ツールチップ
        tooltipShopping: _tooltipShopping,
        // アメニティ　利用可否
        isEnabledAmenity: _isEnabledAmenity,
        // アメニティ　ツールチップ
        tooltipAmenity: _tooltipAmenity,
        // 座席　利用可否
        isEnabledSeat: _isEnabledSeat,
        // 座席　ツールチップ
        tooltipSeat: _tooltipSeat,
        // Wi-Fi 利用可否 Wi-Fiサービスあり
        isWiFiServiceAll: _isWiFiServiceAll,
        // Wi-Fi 利用可否 Wi-Fiサービス可能性あり
        isWiFiServiceASegment: _isWiFiServiceASegment,
        // ラウンジ　ツールチップ
        tooltipLounge: _tooltipLounge,
        // ラウンジ利用可否
        isEnabledLounge: _isEnabledLounge,
        // ラウンジ利用可否識別
        loungeAvailableType: airOffersFlightsList[tsIndex].loungeAvailableType ?? '',
        // ブッキングクラス 表示可否
        isEnabledBookingClass: airOffersFlightsList[tsIndex].bookingClass !== undefined,
        // ブッキングクラス　表示値
        bookingClass: airOffersFlightsList[tsIndex].bookingClass ?? '',
        // NHグループ運航便かどうか 表示判定用
        isNhGroupOperated: travelSolutionsFlights.isNhGroupOperated ?? false,
        // 日本国内線であるかどうか 表示判定用
        isJapanDomesticFlight: travelSolutionsFlights.isJapanDomesticFlight ?? false,

        /** FF選択モーダル内イベント用引数 */
        // 出発空港コード
        departureLocationCode: travelSolutionsFlights.departure?.locationCode ?? '',
        // 到着空港コード
        arrivalLocationCode: travelSolutionsFlights.arrival?.locationCode ?? '',
        // 出発日
        departureDateTime: travelSolutionsFlights.departure?.dateTime ?? '',
        // 販売キャリアコード
        marketingAirlineCode: travelSolutionsFlights.marketingAirlineCode ?? '',
        // 便番号
        marketingFlightNumber: travelSolutionsFlights.marketingFlightNumber ?? '',
        // アップグレード情報
        upgradeInfo: this.upgradeInfo,
      };

      this.segmentList.push(segment);
    });
  }

  /**
   * 未ログインチェック
   * ログインステータスがNOT_LOGINであればtrue
   * @returns
   */
  private isNotLogin() {
    return this._common.isNotLogin();
  }

  /**
   * シートマップリンク押下時に、シートマップ参照へ連携する情報をstoreに格納
   *
   * @param _departureLocationCode
   * @param _arrivalLocationCode
   * @param _departureDateTime
   * @param _marketingAirlineCode
   * @param _marketingFlightNumber
   * @param _bookingClass
   */
  public seatmapReferenceParams(
    _departureLocationCode?: string,
    _arrivalLocationCode?: string,
    _departureDateTime?: string,
    _marketingAirlineCode?: string,
    _marketingFlightNumber?: string,
    _bookingClass?: string
  ) {
    // ※以降、フライト検索画面(R01-P010)で保持された検索条件を、リクエスト用の検索条件とする。
    this.searchFlightCondition = this._searchFlightConditionForRequestService.getData();
    // yyyy-MM-dd'T'HH:mm:ss形式をyyyyMMdd形式に変換する
    const departureDate = this.convertDateTimeToDate(_departureDateTime);

    // リクエスト用検索条件から、搭乗者数を設定
    let _adt: string = this.searchFlightCondition.request.travelers.ADT.toString();
    let _b15: string = this.searchFlightCondition.request.travelers.B15.toString();
    let _chd: string = this.searchFlightCondition.request.travelers.CHD.toString();
    let _inf: string = this.searchFlightCondition.request.travelers.INF.toString();

    let amcMemberNo: string = ''; // ユーザ共通.会員番号 初期化
    const JSessionId = this._common.loadSessionStorage(SessionStorageName.JSESSION_ID); //「国際ASWからの遷移の際に指定されるセッションID」
    const lang = this._common.aswContextStoreService.aswContextData.lang; // ユーザ共通情報（AswContext）に保存された言語情報を取得
    const pointOfSaleId = this.getConnectionKind(); // ユーザ共通.操作オフィスコード＝オフィスコードとなるASWDB(マスタ)のオフィス.ASWTOP識別

    // 未ログインチェック
    if (!this.isNotLogin()) {
      // ログイン済みの場合、ユーザ共通.会員番号を設定
      amcMemberNo = this._common.amcMemberStoreService.amcMemberData.amcNumber;
    }

    // パラメータ送信設定
    const form = document.createElement('form');
    // 遷移先Urlを生成
    let env = '';
    if (environment.envName.startsWith('prd')) {
      env = 'https://aswbe.ana.co.jp';
    } else if (environment.envName.startsWith('stg')) {
      env = 'https://stg.test.aswbe.ana.co.jp';
    } else if (environment.envName.startsWith('dev')) {
      env = 'https://dev.test.aswbe.ana.co.jp';
    }
    const url = `${env}${environment.spa.baseUrl}${environment.spa.app.srv}/informative-seatmap`;
    form.action = url + '?CONNECTION_KIND=' + pointOfSaleId + '&LANG=' + lang;
    form.target = '_blank'; // 別タブ表示指定
    form.method = 'post'; // サーバへの送信方法を指定
    form.style.display = 'none'; //パラメータを非表示

    //パラメータに値を設定
    form.addEventListener('formdata', ({ formData }) => {
      formData.set('marketingAirlineCode', _marketingAirlineCode ?? '');
      formData.set('marketingFlightNumber', _marketingFlightNumber ?? '0');
      /** 出発空港コード */
      formData.set('originLocationCode', _departureLocationCode ?? '');
      /** 到着空港コード */
      formData.set('destinationLocationCode', _arrivalLocationCode ?? '');
      /** ブッキングクラス */
      formData.set('bookingClass', _bookingClass ?? '');
      /** 出発日 */
      formData.set('departureDate', departureDate);
      /** セッションID */
      formData.set('JSessionId', JSessionId ?? '');
      /** AMC会員番号 */
      formData.set('amcMemberNumber', amcMemberNo ?? '');
      /** 搭乗者数(大人) */
      formData.set('numberOfADT', _adt);
      /** 搭乗者数(ヤングアダルト) */
      formData.set('numberOfB15', _b15);
      /** 搭乗者数(小児) */
      formData.set('numberOfCHD', _chd);
      /** 搭乗者数(幼児) */
      formData.set('numberOfINF', _inf);
      /** farefamilyコード */
      formData.set('fareFamilyCode', this.fareFamilyCode ?? '');
      /** farefamily所有航空会社 */
      formData.set('fareFamilyOwnerAirlineCode', 'NH');
    });
    document.body.append(form);

    // パラメータ送信
    form.submit();
    // パラメータ送信後、削除処理
    document.body.removeChild(form);
  }

  // yyyy-MM-dd'T'HH:mm:ss形式をyyyyMMdd形式に変換する
  private convertDateTimeToDate(_departureDateTime: string | undefined): string {
    if (_departureDateTime === undefined) {
      return '';
    }

    const year = _departureDateTime.substring(0, 4);
    const month = _departureDateTime.substring(5, 7);
    const date = _departureDateTime.substring(8, 10);

    return year + month + date;
  }

  /**
   * 1.1.48	アップグレード詳細情報リンク押下時処理
   *
   * @param segment セグメント情報
   * @param segmentIndex セグメントインデックス
   * @param _segmentId セグメントID
   * @param _departureLocationCode 出発空港コード
   * @param _arrivalLocationCode 到着空港コード
   * @param _departureDateTime 出発日
   * @param _marketingAirlineCode 販売キャリアコード
   * @param _marketingFlightNumber 便番号
   */
  public async upgradeDetailInformation(
    segment: Segment,
    segmentIndex: number,
    _segmentId?: string,
    _departureLocationCode?: string,
    _arrivalLocationCode?: string,
    _departureDateTime?: string,
    _marketingAirlineCode?: string,
    _marketingFlightNumber?: string,
    upgradeInfo?: FlightUpgradeInfo
  ) {
    // FF選択モーダル画面に表示している全てのアップグレード詳細情報リンクを非活性にする。
    this.changeAllUpgradeLink.emit({
      allUpgradeLink: true,
    });
    let copySegmentList = structuredClone(this.segmentList);
    // 往復空席照会結果画面storeへの値格納用オブジェクト
    let upgradeDetailInfo: RoundtripFlightAvailabilityInternationalState = {};

    // 当該セグメントアップグレード情報リスト書き換え用
    let newUpgradeInfo: FlightUpgradeInfo | undefined = JSON.parse(JSON.stringify(upgradeInfo));

    // 更新用アップグレード情報リスト
    const upgradeRemainSeatResultList = structuredClone(this.upgradeListSeg ?? []);

    let storedUpgradeList: AirOfferUpgradeInfo[] = JSON.parse(JSON.stringify(this.storeUpgradeList));

    // 搭乗者人数合計（INF以外）
    const travelers = this._R01P030Store.roundtripOwdRequest?.travelers;
    let travelerSum = 0;
    if (travelers?.ADT) {
      travelerSum += travelers.ADT;
    }
    if (travelers?.B15) {
      travelerSum += travelers.B15;
    }
    if (travelers?.CHD) {
      travelerSum += travelers.CHD;
    }
    // 当該セグメントアップグレード情報リストを繰り返す
    for (
      let i = 0;
      upgradeInfo && upgradeInfo.cabinClassUpgradeInfoList && i < upgradeInfo.cabinClassUpgradeInfoList.length;
      i++
    ) {
      /**
       * 当該セグメントアップグレード情報リストに、
       * 当該アップグレード情報.残席状況=”unacquired”(未取得)となるアップグレード情報が存在する場合、以下の項目を基に空席照会時アップグレード可否照会APIを呼び出す。
       */
      if (upgradeInfo.cabinClassUpgradeInfoList[i].seatStatus === 'unacquired') {
        // 空席照会時アップグレード可否照会APIリクエスト作成
        const Type5: Type5ItinerariesInner = {
          originLocationCode: _departureLocationCode ?? '',
          destinationLocationCode: _arrivalLocationCode ?? '',
          departureDateTime: _departureDateTime ?? '',
        };
        let itineraries: Array<Type5ItinerariesInner> = [];
        itineraries.push(Type5);

        this._upgradeAvailabilityRequest = {
          itineraries,
          commonIgnoreErrorFlg: true, // 呼び出し時、エラーハンドリング回避フラグ(commonIgnoreErrorFlg)としてtureを指定する。
          travelerNumber: travelerSum === 0 ? 1 : travelerSum,
        };

        // 空席照会時アップグレード可否照会APIの呼び出し
        if (!(await this._getAPI_upgradeAvailability(this._upgradeAvailabilityRequest))) {
          // エラーの場合処理終了
          return;
        }
        break;
      }
    }

    // 空席照会時アップグレード可否照会マップとして、空席照会時アップグレード可否照会レスポンス.dataを複製した情報を保持する。
    let availabilityInquiry: UpgradeAvailabilityState = { requestIds: [] };
    if (this._upgradeAvailability.data) {
      availabilityInquiry = this._upgradeAvailability;

      // 出発日の変換処理 yyyy-MM-dd形式
      let keyDepartureDate: string = '';
      if (_departureDateTime) {
        keyDepartureDate = this.convertDateToFormatDateString(new Date(_departureDateTime));
      }

      // 以下の処理にて、当該セグメントアップグレード情報リストを更新する
      let apiSegPossibility: vacantInformationForFlight | undefined; //APIセグメント可否(アップグレード可否照会API照会結果)の初期化
      let upgradeTheDay: availabilityInformationForDepartureDate | undefined; // 当該日のアップグレード可否照会マップの初期化

      // 以下の処理にて、当該セグメントに紐づくアップグレード可否照会API照会結果(以降、APIセグメント可否)を求める。
      // 空席照会時アップグレード可否照会マップ.{当該セグメント.departure.dateTime(yyyy-MM-dd形式)}を当該日のアップグレード可否照会マップとする。*/
      upgradeTheDay = Object.entries(availabilityInquiry.data!).find(
        ([key, value]) => value && key === keyDepartureDate
      )?.[1];

      // 取得不可の場合、APIセグメント可否をなしとし、当処理を終了する。(※次の繰り返しを行う)
      if (!upgradeTheDay) {
        // 次の処理へ移行
      } else {
        // 当該日のアップグレード可否照会マップ.{当該セグメント.marketingAirlineCode+当該セグメント.marketingFlightNumber}をAPIセグメント可否とする。
        apiSegPossibility = Object.entries(upgradeTheDay).find(
          ([key, value]) => value && key === _marketingAirlineCode! + _marketingFlightNumber
        )?.[1];

        // APIセグメント可否が存在しない場合、アップグレード詳細情報リンク押下時処理を終了する。 */
        if (!apiSegPossibility) {
          // 次の処理へ移行
        } else {
          // 当該セグメント.アップグレード情報リストを繰り返し、
          // APIセグメント可否{当該アップグレード情報.キャビンクラス}が存在する場合、その値を、当該アップグレード情報.残席状況に設定する。
          newUpgradeInfo?.cabinClassUpgradeInfoList?.map((cabinClassInfo) => {
            for (const [cabinClass, seatStatus] of Object.entries(apiSegPossibility!)) {
              if (cabinClassInfo.cabinClass === cabinClass) {
                cabinClassInfo.seatStatus = seatStatus;
              }
            }
          });

          storedUpgradeList.map((storeAirOfferUpgradeInfo) => {
            storeAirOfferUpgradeInfo?.boundUpgradeInfoList?.map((storeBboundUpgradeInfo, storeBboundIndex) => {
              let boundIndex = this.getBoundIndex();
              if (
                boundIndex === storeBboundIndex &&
                storeBboundUpgradeInfo.travelSolutionId === this.airOfferBounds.travelSolutionId
              ) {
                storeBboundUpgradeInfo?.flightUpgradeInfoList?.map((storeFlightUpgradeInfo) => {
                  storeFlightUpgradeInfo.cabinClassUpgradeInfoList?.map((value) => {
                    for (const [cabinClass, seatStatus] of Object.entries(apiSegPossibility!)) {
                      if (value.cabinClass === cabinClass) {
                        value.seatStatus = seatStatus;
                      }
                    }
                  });
                });
              }
            });
          });

          if (newUpgradeInfo) {
            segment.isEnabledSeatAcquisition = false;
            segment.upgradeInfo = JSON.parse(JSON.stringify(newUpgradeInfo));
            this._changeDetectorRef.detectChanges();
          }
        }
      }
    }

    // 当該セグメント.アップグレード情報リストに、当該アップグレード情報.残席状況に”waitlisting”(空席待ち)となるアップグレード情報が存在する場合、
    // アップグレード空席待ち人数取得APIを呼び出す。
    for (
      let j = 0;
      newUpgradeInfo && newUpgradeInfo.cabinClassUpgradeInfoList && j < newUpgradeInfo.cabinClassUpgradeInfoList.length;
      j++
    ) {
      if (newUpgradeInfo.cabinClassUpgradeInfoList[j].seatStatus === 'waitlisting') {
        // リクエスト作成
        if (_departureDateTime && _marketingAirlineCode && _marketingFlightNumber) {
          this._upgradeWaitlistRequest = {
            departureDateTime: _departureDateTime,
            marketingAirlineCode: _marketingAirlineCode,
            marketingFlightNumber: _marketingFlightNumber,
            commonIgnoreErrorFlg: true,
          };

          // アップグレード空席待ち人数取得APIの呼び出し
          await this._getAPI_upgradeWaitlist(this._upgradeWaitlistRequest);
        }

        // アップグレード空席待ち人数取得APIから取得した値を、APIセグメント空席待ち人数とする。
        const response: UpgradeWaitlistState = JSON.parse(JSON.stringify(this._upgradeWaitlist));

        // 当該セグメント.アップグレード情報リストを繰り返し、APIセグメント空席待ち人数.{当該アップグレード情報.キャビンクラス}が存在する場合、以下の処理を行う。
        newUpgradeInfo.cabinClassUpgradeInfoList?.map((cabinClassInfo) => {
          for (const [cabinClass, vacancyNum] of Object.entries(response)) {
            if (cabinClassInfo.cabinClass === cabinClass) {
              // 当該アップグレード情報.空席数にAPIセグメント空席待ち人数.{当該アップグレード情報.キャビンクラス}の値を設定する。
              cabinClassInfo.vacancyNum = vacancyNum;
              // 当該アップグレード情報.残席状況に”acquired”(取得済)を設定する。
              cabinClassInfo.seatStatus = 'acquired';
            }
          }
        });

        storedUpgradeList.map((storeAirOfferUpgradeInfo) => {
          storeAirOfferUpgradeInfo?.boundUpgradeInfoList?.map((storeBboundUpgradeInfo, storeBboundIndex) => {
            let boundIndex = this.getBoundIndex();
            if (
              boundIndex === storeBboundIndex &&
              storeBboundUpgradeInfo.travelSolutionId === this.airOfferBounds.travelSolutionId
            ) {
              storeBboundUpgradeInfo?.flightUpgradeInfoList?.map((storeFlightUpgradeInfo) => {
                storeFlightUpgradeInfo.cabinClassUpgradeInfoList?.map((value) => {
                  for (const [cabinClass, vacancyNum] of Object.entries(response)) {
                    if (value.cabinClass === cabinClass) {
                      value.seatStatus = 'acquired';
                      value.vacancyNum = vacancyNum;
                    }
                  }
                });
              });
            }
          });
        });

        if (newUpgradeInfo) {
          segment.isEnabledSeatAcquisition = false;
          segment.upgradeInfo = JSON.parse(JSON.stringify(newUpgradeInfo));
          this._changeDetectorRef.detectChanges();
        }
        break;
      }
    }

    // 更新用アップグレード情報リストで、往復空席照会結果画面store.アップグレード情報リストを更新
    if (upgradeRemainSeatResultList.length !== 0) {
      // 往復空席照会結果画面storeの値を更新
      upgradeDetailInfo = {
        upgradeInfoList: storedUpgradeList,
      };
      this._roundtripFlightAvailabilityInternationalService.updateRoundtripFlightAvailabilityInternational(
        upgradeDetailInfo
      );

      // 画面表示値が処理結果に切り替わるように更新
      segment = {
        ...segment,
        upgradeRemainSeatList: upgradeRemainSeatResultList,
      };

      copySegmentList[segmentIndex] = segment;
      // 値の更新と対象外セグメントのリンクを活性化
      this.changeAllUpgradeLink.emit({
        allUpgradeLink: false,
      });
    }
  }

  /**
   * Dateオブジェクトを日付文字列のフォーマットへ変換する yyyy-MM-dd
   */
  private convertDateToFormatDateString(date: Date): string {
    if (date !== undefined) {
      return (
        date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      );
    }
    return '';
  }

  /**
   * 空席照会時アップグレード可否照会API呼び出し
   */
  private _getAPI_upgradeAvailability(
    getUpgradeAvailabilityRequestParam: UpgradeAvailabilityRequest
  ): Promise<boolean> {
    this._pageLoadingService.startLoading();
    //　空席照会時アップグレード可否照会API呼び出し、受信後処理
    return new Promise<boolean>((resolve) => {
      // 空席照会時アップグレード可否照会API実行
      this._upgradeAvailabilityService.setUpgradeAvailabilityFromApi(getUpgradeAvailabilityRequestParam);

      // 空席照会時アップグレード可否照会API実行後処理
      this._common.apiErrorResponseService.clearApiErrorResponse(); //APIエラー情報を事前にクリア

      this.subscribeService(
        '_upgradeAvailability',
        this._upgradeAvailabilityService.getUpgradeAvailabilityObservable(),
        (response) => {
          if (response.isPending === false) {
            this._pageLoadingService.endLoading();
            this.deleteSubscription('_upgradeAvailability');
            if (response.isFailure) {
              this._fareFamilySelectorModalComponent.closeModal();
              // 空席照会時アップグレード可否照会レスポンス.errors[0].code=”EBAZ000063”の場合、
              // エラーメッセージID＝”E0091”(アップグレード空席状況が取得できなかった)にて継続可能なエラー情報を指定し、
              // アップグレード詳細情報リンク押下時処理を終了する。
              if (this._common.apiError?.errors?.[0].code === 'EBAZ000063') {
                this._errorsHandlerSvc.setRetryableError(PageType.PAGE, {
                  errorMsgId: 'E0091',
                  apiErrorCode: 'EBAZ000063',
                });
              } else {
                // 継続不可能エラータイプ＝”system”(システムエラー)にて継続不可能なエラー情報を指定
                this._errorsHandlerSvc.setNotRetryableError({
                  errorType: ErrorType.SYSTEM,
                  apiErrorCode: this._common.apiError?.errors?.[0].code,
                });
              }
              resolve(false);
            } else {
              // 正常系
              /* ※以降の処理は、エラーが発生していない空席照会時アップグレード可否照会レスポンスが通知された場合、処理を行う。当処理はstoreを介して行う。 */
              // 空席照会時アップグレード可否照会マップとして、空席照会時アップグレード可否照会レスポンス.dataを複製した情報を保持する。
              this._upgradeAvailability = response;
              resolve(true);
            }
          }
        }
      );
    });
  }

  /**
   * アップグレード空席待ち人数取得API呼び出し
   */
  private _getAPI_upgradeWaitlist(getUpgradeWaitlistRequestParam: UpgradeWaitlistRequest) {
    this._pageLoadingService.startLoading();
    // アップグレード空席待ち人数取得API実行
    this._upgradeWaitlistService.setDataFromApi(getUpgradeWaitlistRequestParam);

    // アップグレード空席待ち人数取得API実行後処理
    this._common.apiErrorResponseService.clearApiErrorResponse(); //APIエラー情報を事前にクリア

    // アップグレード空席待ち人数取得API呼び出し、受信後処理
    return new Promise<boolean>((resolve) => {
      this.subscribeService(
        '_upgradeWaitlist',
        this._upgradeWaitlistService.getUpgradeWaitListObservable(),
        (response) => {
          if (response.isPending === false) {
            this._pageLoadingService.endLoading();
            this.deleteSubscription('_upgradeWaitlist');
            if (response.isFailure) {
              // エラーが発生したアップグレード空席待ち人数取得レスポンスが通知された場合、FF選択モーダルを非表示にし、条件に応じて処理を行う
              this.isErrorUpgradeWaitlistResponse();
              resolve(false);
            } else {
              // 正常系
              /* ※以降の処理は、エラーが発生していないアップグレード空席待ち人数取得レスポンスが通知された場合、処理を行う。当処理はstoreを介して行う。 */
              // アップグレード空席待ち人数取得マップとして、アップグレード空席待ち人数取得レスポンス.dataを複製した情報を保持する。
              this._upgradeWaitlist = response;
              resolve(true);
            }
          }
        }
      );
    });
  }

  /**
   * エラーが発生したアップグレード空席待ち人数取得レスポンスが通知された場合、FF選択モーダルを非表示にし、条件に応じて処理を行う
   */
  private isErrorUpgradeWaitlistResponse() {
    this._fareFamilySelectorModalComponent.closeModal();
    // アップグレード空席待ち人数取得レスポンス.errors[0].code=”EBAZ000067”の場合、
    // エラーメッセージID＝”E0095”(アップグレード空席待ち人数が取得できなかった)にて継続可能なエラー情報を指定し、アップグレード詳細情報リンク押下時処理を終了する。
    const errorCode = this._common.apiError?.errors?.[0].code;
    if (errorCode === 'EBAZ000067') {
      this._common.errorsHandlerService.setRetryableError(PageType.PAGE, {
        apiErrorCode: errorCode,
        errorMsgId: 'E0095',
      });
    }
    // 上記以外の場合、継続不可能エラータイプ＝”system”(システムエラー)にて継続不可能なエラー情報を指定し、アップグレード詳細情報リンク押下時処理を終了する。
    if (errorCode !== 'EBAZ000067') {
      // 継続不可能エラータイプ＝”system”(システムエラー)にて継続不可能なエラー情報を指定
      const errorInfo: NotRetryableErrorModel = {
        errorType: ErrorType.SYSTEM,
        apiErrorCode: errorCode,
      };
      this._errorsHandlerSvc.setNotRetryableError(errorInfo);
      // 遷移元画面に遷移後、アップグレード詳細情報リンク押下処理を終了する
    }
  }

  /**
   * お食事・お飲み物 ～ ラウンジ
   * 以下、当該セグメント関連情報.isNhGroupOperated=true(NHグループ運航便)を条件に含む場合、以下条件を満たすASWDB(マスタ)サービスコンテンツ.サービス説明に応じて表示する。
   *  1  当該セグメント関連情報.cabin=サービスコンテンツ.Cabinclass
   *  2  以下いずれかの条件を満たす
   *   2.1 当該セグメント関連情報.isJapanDomesticFlight=trueの場合、サービスコンテンツ.セグメント区分が”D”(日本国内区間)
   *   2.2 上記以外の場合、サービスコンテンツ.セグメント区分が”I”(国際区間)
   *  3  サービスコンテンツ.サービスタイプ=以下の通り、値に応じて設定
   *
   * @param cabinClass キャビンクラス
   * @param itineraryType セグメント区分
   * @returns serviceContentsByServiceType セグメント区分、キャビンクラスで指定したサービスコンテンツ情報
   */
  private getServiceContentsByItineraryType(cabinClass: string, itineraryType: string) {
    let listDataAkamaiData: ServiceContentsByItineraryTypeModel = {};
    let serviceContentsByServiceType: ServiceContentsByItineraryTypeServiceType[] = [];

    // キャッシュを取得
    listDataAkamaiData = this._aswMasterSvc.aswMaster[MasterStoreKey.SERVICE_CONTENTS] || {};

    if (listDataAkamaiData) {
      let serviceContentsByCabinClass = listDataAkamaiData[itineraryType] as ServiceContentsByItineraryTypeCabin;
      if (serviceContentsByCabinClass) {
        serviceContentsByServiceType = serviceContentsByCabinClass[
          cabinClass
        ] as ServiceContentsByItineraryTypeServiceType[];
      }
    }

    return serviceContentsByServiceType;
  }

  /**
   * ユーザ共通.操作オフィスコード＝オフィスコードとなるASWDB(マスタ)のオフィス.ASWTOP識別を取得
   * @returns
   */
  private getConnectionKind(): string {
    // ユーザ共通.操作オフィスコード=オフィスコードとなるASWDB(マスタ)のオフィス.ASWTOP識別
    let result = '';
    let _officeAll = this._aswMasterSvc.aswMaster[MASTER_TABLE.OFFICE_ALL.key];
    _officeAll.forEach((officeAll: M_OFFICE) => {
      if (officeAll.office_code === this._common.aswContextStoreService.aswContextData.pointOfSaleId) {
        result = officeAll.connection_kind ?? '';
      }
    });
    return result;
  }

  /**
   * アップグレード情報リスト追加処理
   */
  private getStoreUpgradeList(upgradeRemainSeatResultList: Array<FlightUpgradeInfo>, travelSolutionsId: string) {
    this.storeUpgradeList &&
      this.storeUpgradeList.forEach((airOfferUpgradeInfo) => {
        airOfferUpgradeInfo?.boundUpgradeInfoList?.forEach((boundUpgradeInfo, bIndex) => {
          // TSIdからboundIndexを判別
          let boundIndex = this.getBoundIndex();
          // boundIndexとtravelSolutionIdが一致する場合、当該アップグレード情報リストに追加する
          if (bIndex === this.getBoundIndex()) {
            if (boundUpgradeInfo.travelSolutionId === this.airOfferBounds.travelSolutionId) {
              boundUpgradeInfo?.flightUpgradeInfoList?.forEach((flightUpgradeInfo) => {
                upgradeRemainSeatResultList.push(flightUpgradeInfo);
              });
            }
          }
        });
      });

    // 当該セグメント アップグレード情報リストに設定
    this.upgradeListSeg = upgradeRemainSeatResultList;

    return upgradeRemainSeatResultList;
  }

  /**
   * TSIdからboundIndexを判別し取得
   * @returns boundIndex
   */
  private getBoundIndex(): number {
    let tsKey = this.airOfferBounds.travelSolutionId?.slice(0, 1);
    if (tsKey === 'o') {
      return 0;
    } else {
      return 1;
    }
  }

  /**
   * 機内サービスアイコンのツールチップ画像要素を生成する
   * @param src アイコンのパス
   * @param altKey alt文言のキー
   * @param width アイコンの幅
   * @param height アイコンの高さ
   * @returns imgタグ
   */
  public getTooltipIconImage(src: string, altKey: string, width: number, height: number): string {
    const alt = this._staticMsgPipe.transform(altKey);
    return `<img src="${src}" alt="${alt}" width="${width}" height="${height}">`;
  }
}
